/* Sekme 5 — sahne alanlar. Sıralama sahneye çıkış sırasına göre (içerikten gelir).
   Uzun notlar katlanır: kart üç satır gösterir, dokununca açılır. */

import { useState } from "react";
import type { Lang, SiteContent } from "../../shared/types.js";
import { t } from "../../shared/types.js";
import { ui } from "../lib/i18n.js";
import { IconChevron } from "../components/Icons.js";

const initials = (name: string): string =>
  name
    .replace(/^(Prof\.|Dr\.|Doç\.)\s*/gi, "")
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((p) => p[0])
    .join("")
    .toUpperCase();

export function SpeakersTab({ content, lang }: { content: SiteContent; lang: Lang }) {
  const [open, setOpen] = useState<string | null>(null);

  return (
    <div style={{ paddingTop: 28 }}>
      <h2 className="eyebrow">{ui("navSpeakers", lang)}</h2>
      <h1 className="display">{ui("speakersTitle", lang)}</h1>
      <p className="lede">{ui("speakersLede", lang)}</p>

      <div className="stack" style={{ gap: 14, marginTop: 24 }}>
        {content.speakers.map((sp, i) => {
          const isOpen = open === sp.id;
          const bio = t(sp.bio, lang);
          const quote = t(sp.quote, lang);

          return (
            <article
              key={sp.id}
              className="card rise pressable"
              style={{ ["--i" as string]: Math.min(i, 8), padding: 0 }}
            >
              <button
                type="button"
                className="acc"
                aria-expanded={isOpen}
                aria-controls={"sp-" + sp.id}
                aria-label={sp.name + " — " + ui(isOpen ? "less" : "more", lang)}
                onClick={() => setOpen(isOpen ? null : sp.id)}
                style={{ padding: 20 }}
              >
                <div style={{ display: "flex", gap: 14, alignItems: "flex-start" }}>
                  {sp.photo ? (
                    <img
                      className="portrait"
                      src={"/fotograflar/" + sp.photo}
                      alt=""
                      loading="lazy"
                      decoding="async"
                      width={66}
                      height={84}
                    />
                  ) : (
                    <span className="portrait portrait--empty" aria-hidden="true">
                      {initials(sp.name)}
                    </span>
                  )}

                  <div style={{ minWidth: 0, flex: 1 }}>
                    <h3 className="serif" style={{ fontSize: 24, lineHeight: 1.15, margin: 0 }}>
                      {sp.name}
                    </h3>
                    <p style={{ margin: "5px 0 0", color: "var(--gold)", fontSize: 14.5 }}>
                      {t(sp.role, lang)}
                    </p>
                    {sp.time && (
                      <p className="dim tnum" style={{ margin: "4px 0 0", fontSize: 14.5 }}>
                        {sp.time}
                      </p>
                    )}
                  </div>
                </div>

                {bio && (
                  <p
                    className="muted clamp"
                    data-open={isOpen}
                    style={{ margin: "14px 0 0", fontSize: 15.5, lineHeight: 1.68 }}
                  >
                    {bio}
                  </p>
                )}

                {bio && (
                  <span
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      gap: 6,
                      marginTop: 10,
                      color: "var(--gold)",
                      fontSize: 13,
                      letterSpacing: "0.08em",
                      textTransform: "uppercase",
                      fontWeight: 600,
                    }}
                  >
                    {ui(isOpen ? "less" : "more", lang)}
                    <IconChevron className="acc__caret" open={isOpen} />
                  </span>
                )}
              </button>

              {quote && (
                <div className="acc__panel" data-open={isOpen} id={"sp-" + sp.id}>
                  <div className="acc__inner">
                    <p
                      className="serif"
                      style={{
                        margin: 0,
                        padding: "0 20px 20px",
                        fontSize: 19,
                        lineHeight: 1.45,
                        fontStyle: "italic",
                        color: "var(--sand)",
                      }}
                    >
                      “{quote}”
                    </p>
                  </div>
                </div>
              )}
            </article>
          );
        })}
      </div>
    </div>
  );
}
